import styles from "../../styles/stylesMetrics.module.css"
function MetricCard({ label, value, sub, colorClass }) {
  return (
    <div className={styles.metricCard}>
      <div className={`${styles.metricValue} ${colorClass || 'text-[var(--color-primary)]'}`}>{value}</div>
      <div className={styles.metricLabel}>{label}</div>
      {sub && <div className={styles.metricSub}>{sub}</div>}
    </div>
  );
}
export default MetricCard